const img = require('./ActiveBaseOption.svg'); export default img;